import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LOCALE, isRtlLocale } from '@/lib/locale';
import fa from './locales/fa.json';

const resources = {
  fa: { translation: fa }
} as const;

function applyDocumentLanguage(lng: string) {
  const base = lng.split('-')[0] ?? lng;
  document.documentElement.lang = base;
  document.documentElement.dir = isRtlLocale(base) ? 'rtl' : 'ltr';
}

if (typeof window !== 'undefined') {
  try {
    localStorage.setItem('i18nextLng', DEFAULT_LOCALE);
  } catch {
    // ignore private mode / blocked storage
  }
}

void i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  supportedLngs: [DEFAULT_LOCALE],
  interpolation: {
    escapeValue: false
  }
});

i18n.on('languageChanged', applyDocumentLanguage);
applyDocumentLanguage(DEFAULT_LOCALE);

export default i18n;
